import {
  GRUPOFAMILIAR_SUCCESS,
  GRUPOFAMILIAR_LOADING,
  GRUPOFAMILIAR_ERROR,
  GRUPOFAMILIAR_RESET,
  GRUPOFAMILIAR_AUTORIZAR,
  SEARCH_DNI_FAMILIAR,
  SEARCH_DNI_FAMILIAR_SUCCESS,
  SEARCH_DNI_FAMILIAR_FAIL,
  ADD_FAMILIAR_POST,
  ADD_FAMILIAR_POST_SUCCESS,
  ADD_FAMILIAR_POST_FAIL,
  GET_TIPOS_PARENTESCO,
  GET_TIPOS_PARENTESCO_SUCCESS,
  GET_TIPOS_PARENTESCO_FAIL,
  LIMPIAR_ADD_FAMILIAR,
  VINCULO_PUT,
  VINCULO_PUT_SUCCESS,
  VINCULO_PUT_FAIL,
  LIMPIAR_POST_FAMILIAR,
  LIMPIAR_DELETE_FAMILIAR,
  DELETE_VINCULO_FAMILIAR,
  DELETE_VINCULO_FAMILIAR_SUCCESS,
  DELETE_VINCULO_FAMILIAR_FAIL,
  ADD_FAMILIAR_CON_CLAVE,
  ADD_FAMILIAR_CON_CLAVE_SUCCESS,
  LIMPIAR_ADD_FAMILIAR_CLAVE,
  ADD_FAMILIAR_CON_CLAVE_FAIL,
  EDITAR_DERECHOS,
  EDITAR_DERECHOS_SUCCESS,
  EDITAR_DERECHOS_FAIL,
} from "../../ActionTypes";

import axiosLogin from "../../../../global/helpers/axiosLogin";

export const wsGetGrupoFamiliar = (foto, nextStep) => (dispatch) => {
  dispatch({
    type: GRUPOFAMILIAR_LOADING,
  });

  axiosLogin(null, "familiares").then((respuesta) => {
    respuesta
      .get(`/shared/Familia/parentesco/${foto ? foto : false}`)
      .then((res) => {
        dispatch({
          type: GRUPOFAMILIAR_SUCCESS,
          payload: res.data,
        });
        if (nextStep) nextStep(true, res.data);
      })
      .catch((err) => {
        let error = {
          detail: err.response
            ? err.response.data
            : "Error al contactar el server.",
        };
        if (nextStep) nextStep(false, error);
        dispatch({
          type: GRUPOFAMILIAR_ERROR,
          payload: error,
        });
      });
  });
};

export const grupoFamiliarReset = () => (dispatch) => {
  dispatch({
    type: GRUPOFAMILIAR_RESET,
  });
};

export const deleteVinculo = (idFamiliar, nextStep) => (dispatch) => {
  dispatch({ type: DELETE_VINCULO_FAMILIAR });
  axiosLogin(null, "familiares").then((respuesta) => {
    respuesta
      .delete(`/shared/Familia/parentesco/${idFamiliar}`)
      .then((resp) => {
        dispatch({ type: DELETE_VINCULO_FAMILIAR_SUCCESS, payload: resp });
        if (nextStep) nextStep(true, resp.data);
      })
      .catch((erro) => {
        dispatch({ type: DELETE_VINCULO_FAMILIAR_FAIL, payload: erro });
        if (nextStep) nextStep(false, erro);
      });
  });
};

export const wsGetDniPariente = (DNI) => (dispatch) => {
  dispatch({ type: SEARCH_DNI_FAMILIAR });
  axiosLogin(null, "familiares").then((respuesta) => {
    respuesta
      .get(`/shared/Familia/datos/${DNI}`)
      .then((resp) => {
        dispatch({ type: SEARCH_DNI_FAMILIAR_SUCCESS, payload: resp.data });
      })
      .catch((err) => {
        dispatch({
          type: SEARCH_DNI_FAMILIAR_FAIL,
          payload:
            !err.response?.data || typeof err?.response?.data !== "string"
              ? err.request.status
              : err.response.data,
        });
      });
  });
};

export const wsPostAgregarFamiliar = (form, nextStep) => (dispatch) => {
  dispatch({ type: ADD_FAMILIAR_POST });
  axiosLogin(null, "familiares").then((respuesta) => {
    respuesta
      .post("/shared/Familia/parentesco", form)
      .then((resp) => {
        dispatch({ type: ADD_FAMILIAR_POST_SUCCESS, payload: resp });
        if (nextStep) nextStep(true, resp.data);
      })
      .catch((resp) => {
        dispatch({ type: ADD_FAMILIAR_POST_FAIL, payload: resp });
        if (nextStep) nextStep(false, resp);
      });
  });
};

export const wsGetTiposParentesco = (nextStep) => (dispatch) => {
  dispatch({ type: GET_TIPOS_PARENTESCO });
  axiosLogin(null, "familiares").then((respuesta) => {
    respuesta
      .get("/shared/Familia/tipo_parentesco")
      .then((resp) => {
        dispatch({ type: GET_TIPOS_PARENTESCO_SUCCESS, payload: resp });
        if (nextStep) nextStep(true, resp.data);
      })
      .catch((err) => {
        dispatch({ type: GET_TIPOS_PARENTESCO_FAIL, payload: err });
        if (nextStep) nextStep(false, err);
      });
  });
};

export const wsAutorizarFamiliar =
  (idParentescoSolicitud, clave, nextStep) => (dispatch) => {
    dispatch({
      type: ADD_FAMILIAR_CON_CLAVE,
    });

    axiosLogin(null, "familiares").then((respuesta) => {
      respuesta
        .put(`/shared/Familia/altaParentescoConClave/${idParentescoSolicitud}`, {
          idPaciente: idParentescoSolicitud,
          claveWebPacDestino: clave,
        })
        .then((res) => {
          dispatch({
            type: ADD_FAMILIAR_CON_CLAVE_SUCCESS,
            payload: res.altaEncuesta,
          });
          if (nextStep) nextStep(true, res.data);
        })
        .catch((err) => {
          let error = {
            detail: err.response
              ? err.response.data
              : "Error al contactar el server.",
          };

          dispatch({
            type: ADD_FAMILIAR_CON_CLAVE_FAIL,
            payload: error,
          });
          if (nextStep) nextStep(false, error.detail);
        });
    });
  };

export const limpiarAddFamiliar = () => (dispatch) => {
  dispatch({ type: LIMPIAR_ADD_FAMILIAR });
};

export const limpiarAddFamiliarClave = () => (dispatch) => {
  dispatch({ type: LIMPIAR_ADD_FAMILIAR_CLAVE });
};

export const wsPutVinculo = (form, id, nextStep) => (dispatch) => {
  dispatch({
    type: VINCULO_PUT,
  });

  axiosLogin(null, "familiares").then((respuesta) => {
    respuesta
      .put(`/shared/Familia/alta_parentesco/${id}`, form)
      .then((res) => {
        dispatch({
          type: VINCULO_PUT_SUCCESS,
          payload: res,
        });
        if (nextStep) nextStep(true, res.data);
      })
      .catch((err) => {
        let error = {
          detail: err.response
            ? err.response.data
            : "Error al contactar el server.",
        };

        dispatch({
          type: VINCULO_PUT_FAIL,
          payload: error,
        });
        if (nextStep) nextStep(false, error.detail);
      });
  });
};

export const limpiarPostFamiliar = () => (dispatch) => {
  dispatch({ type: LIMPIAR_POST_FAMILIAR });
};

export const limpiarDeleteFamiliar = () => (dispatch) => {
  dispatch({ type: LIMPIAR_DELETE_FAMILIAR });
};

export const wsPutEditarDerechos = (form, nextStep) => (dispatch) => {
  dispatch({ type: EDITAR_DERECHOS });
  axiosLogin(null, "familiares").then((respuesta) => {
    respuesta
      .put(`/shared/Familia/edito_parentesco/${form.idpaciente2}`, form)
      .then((resp) => {
        dispatch({ type: EDITAR_DERECHOS_SUCCESS, payload: resp });
        if (nextStep) nextStep(true, resp.data);
      })
      .catch((err) => {
        dispatch({ type: EDITAR_DERECHOS_FAIL, payload: err });
        if (nextStep) nextStep(false, err);
      });
  });
};
